import React, { useContext, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import CardStatistique from "../components/statistique/cardStatistiques";
import InspectionsDashboard from "../components/table/inspection";
import DriversDashbord from "../components/table/driver";

const HomeComponent = () => {
  const history = useContext(HistoryContext);
  useEffect(() => {
    document.title = `Tableau de bord | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb page="Tableau de bord" history={history} />
        <Row>
          <Col lg={12}>
            <CardStatistique/>
          </Col>
          <Col lg={6}>
            <InspectionsDashboard/>
          </Col>
          <Col lg={6}>
            <DriversDashbord/>
          </Col>
        </Row>
      </Container>
    </div>
  );  
};

export default HomeComponent;
